var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('VueSlickCarousel',{attrs:{"arrows":true,"dots":false}},_vm._l((_vm.sampleImages),function(img,i){return _c('div',{key:i,staticClass:"sample-image-gallery"},[_c('img',{attrs:{"src":img.path,"alt":""}})])}),0)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }